import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PATHS } from '@routes/paths';
import authRoutes from './auth';
import guestRoutes from './guest';
import errorRoutes from './error';

export const router = createBrowserRouter([
  {
    path: PATHS.root,
    element: <Navigate to={PATHS.main} replace />,
  },
  {
    path: PATHS.badge.index,
    element: <Navigate to={PATHS.badge.list} replace={true} />,
  },
  ...authRoutes,
  ...guestRoutes,
  ...errorRoutes,
  { path: '*', element: <Navigate to="/404" replace /> },
]);
